import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface LiveListenSignalsState {
  // true once we have seen any prospect-side transcript for the session
  sessionIdToProspectSpoke: Record<string, boolean>
  // last timestamp (ms) we observed a prospect-side word per session
  sessionIdToProspectLastMs: Record<string, number>
}

const initialState: LiveListenSignalsState = {
  sessionIdToProspectSpoke: {},
  sessionIdToProspectLastMs: {},
}

export const liveListenSignalsSlice = createSlice({
  name: 'liveListenSignals',
  initialState,
  reducers: {
    markProspectSpoke(state, action: PayloadAction<{ sessionId: string, atMs?: number }>) {
      state.sessionIdToProspectSpoke[action.payload.sessionId] = true
      state.sessionIdToProspectLastMs[action.payload.sessionId] = action.payload.atMs ?? Date.now()
    },
    resetProspectSpoke(state, action: PayloadAction<{ sessionId: string }>) {
      delete state.sessionIdToProspectSpoke[action.payload.sessionId]
      delete state.sessionIdToProspectLastMs[action.payload.sessionId]
    }
  }
})

export const { markProspectSpoke, resetProspectSpoke } = liveListenSignalsSlice.actions


